<form [formGroup]="androidForm">
    <div>
        <ul class="mb-2 nav nav-tabs border-0">
            <li class="nav-item">
                <button [class.active]="tabs === 0" type="button" (click)="tabs = 0" class="nav-link">Informações gerais</button>
            </li>
            <li class="nav-item">
                <button [disabled]="!parentForm().controls['accountantId'].valid" [class.active]="tabs === 1" type="button" (click)="tabs = 1" class="nav-link">Arquivos</button>
            </li>
        </ul>

        <div [class.d-none]="tabs !== 0" class="gap-1 row">
            <div class="col-md-4">
                <label>Status</label>
                <div class="input-group mb-1">
                    <select formControlName="status" class="form-select">
                        <option value="1">Produção</option>
                        <option value="2">Homologação</option>
                        <option value="0">Não publicado</option>
                    </select>
                </div>
                
                <label for="package-name">Package Name</label>
                <div class="input-group mb-1">
                    <input formControlName="packageName" class="form-control" id="package-name" type="text">     
                </div>

                <label for="service-account-private-key">Service Account Private Key</label>
                <div class="input-group mb-1">
                    <textarea formControlName="serviceAccountPrivateKey" class="form-control" id="service-account-private-key" type="text"> </textarea>
                </div>
            </div>
            <div class="col-md-4">
                <label for="sha256-certificate-fingerPrint">Certificate SHA256</label>
                <div class="input-group mb-1">
                    <input formControlName="sha256CertificateFingerPrint" class="form-control" id="sha256-certificate-fingerPrint" type="text">     
                </div>

                <label for="service-account-email">Service Account Email</label>
                <div class="input-group mb-1">
                    <input formControlName="serviceAccountEmail" class="form-control" id="service-account-email" type="text">     
                </div>
            </div>
        </div>

        <div [class.d-none]="tabs !== 1" class="row">
            <div class="col-md-4">
                <label for="keytool-link">Keytool</label>
                <div class="align-items-center gap-2 input-group mb-1">
                    <input readonly id="keytool-link" formControlName="keytoolLink" type="text" class="form-control">
                    <app-whitelabel-android-credentials-upload
                        [type]="'keytool'"
                        (successEvent$)="onKeytoolUploadSuccess($event)"
                        (errorEvent$)="onFileUploadError()"
                    >
                    </app-whitelabel-android-credentials-upload>
                </div>

                <label for="store-link">Store</label>
                <div class="align-items-center gap-2 input-group mb-1">
                    <input readonly id="store-link" formControlName="storeLink" type="text" class="form-control">
                    <app-whitelabel-android-credentials-upload
                        [type]="'store'"
                        (successEvent$)="onStoreUploadSuccess($event)"
                        (errorEvent$)="onFileUploadError()"
                    >
                    </app-whitelabel-android-credentials-upload>
                </div>

                <label for="google-services-link">Google Services Json</label>
                <div class="align-items-center gap-2 input-group mb-1">
                    <input readonly id="google-services-link" formControlName="googleServicesJsonLink" type="text" class="form-control">
                    <app-whitelabel-android-google-services-upload
                        (successEvent$)="onGoogleServicesUploadSuccess($event)"
                        (errorEvent$)="onFileUploadError()"
                    >
                    </app-whitelabel-android-google-services-upload>
                </div>
            </div>

            <div class="col-md-4">
                <label for="icons-links">Icons</label>
                <div class="align-items-center gap-2 input-group mb-1">
                    <input readonly id="icons-links" formControlName="iconsLinks" type="text" class="form-control">
                    <app-whitelabel-android-icons-upload
                        [type]="'icons'"
                        (successEvent$)="onIconsUploadSuccess($event)"
                        (errorEvent$)="onFileUploadError()"
                    >
                    </app-whitelabel-android-icons-upload>
                </div>

                <label for="app-icon-link">App Icon</label>
                <div class="align-items-center gap-2 input-group mb-1">
                    <input readonly id="app-icon-link" formControlName="appIconLink" type="text" class="form-control">
                    <app-whitelabel-android-icons-upload
                        [type]="'appIcon'"
                        (successEvent$)="onIconsUploadSuccess($event)"
                        (errorEvent$)="onFileUploadError()"
                    >
                    </app-whitelabel-android-icons-upload>
                </div>
            </div>
        </div>
    </div>
</form>